export var SubscriptionStatuses;
(function (SubscriptionStatuses) {
    SubscriptionStatuses["FreeTrial"] = "Free Trial";
    SubscriptionStatuses["ExpiredTrial"] = "Expired Trial";
    SubscriptionStatuses["Paid"] = "Paid";
    SubscriptionStatuses["Paused"] = "Paused";
    SubscriptionStatuses["OverdueInvoice"] = "Overdue Invoice";
    SubscriptionStatuses["Churned"] = "Churned";
})(SubscriptionStatuses || (SubscriptionStatuses = {}));
